import useBreadcrumb from "../../core/hooks/useBreadcrumb";
import OrdemLocacaoLista from "../features/OrdemLocacaoLista";

export default function LocacaoListaView() {
  useBreadcrumb("Ordem de Locação/Consulta");

  return <OrdemLocacaoLista />;
}
